/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'
import theme from 'theme'

import { Modal, Header, Content, Actions } from 'components/Modals/Modal'
import Button from 'components/Button'
import InputContainer from 'components/Inputs/Container'
import Dropdown from 'components/Dropdown'
import { SettingsDropdown } from '../SettingsDropdown'
import { useTranslation } from 'react-i18next'

export const SettingsModalContent = ({
  language,
  country,
  city,
  available_countries,
  available_languages,
  getAvailableCities,
  submitting,
  handleClose,
  handleUpdateLanguageAndTimezone,
  handleCityChange,
  handleCountryChange,
  handleLanguageChange
}) => {
  const { t } = useTranslation()
  // debugger;s
  return (
    <Modal size="large" modalName="UserSettingsModal">
      <Header>{t('user_settings')}</Header>
      <Content>
        <InputContainer id="language_selector" label={t('language')}>
          <Dropdown className="SettingDropdown" onSelect={handleLanguageChange}>
            {dropdownProps => (
              <SettingsDropdown
                {...dropdownProps}
                settingsItem={language}
                allSettings={available_languages}
                handleSettingChange={handleLanguageChange}
                id={'language_selector'}
              />
            )}
          </Dropdown>
        </InputContainer>
        <InputContainer
          id="timezone_selector"
          label={t('timezone')}
          description={t('setting_modal_timezone_description')}>
          <Dropdown className="SettingDropdown" onSelect={handleCountryChange}>
            {dropdownProps => (
              <SettingsDropdown
                {...dropdownProps}
                settingsItem={country}
                allSettings={available_countries}
                handleSettingChange={handleCountryChange}
                id={'country_selector'}
              />
            )}
          </Dropdown>
          <Dropdown className="SettingDropdown" onSelect={handleCountryChange}>
            {dropdownProps => (
              <SettingsDropdown
                {...dropdownProps}
                settingsItem={city}
                allSettings={getAvailableCities(country)}
                handleSettingChange={handleCityChange}
                // label={t('city')}
                id={'city_selector'}
              />
            )}
          </Dropdown>
        </InputContainer>
        <div
          css={css`
            margin-top: ${theme.units.unit400}px;
            margin-bottom: ${theme.units.unit400}px;
            font-size: 14px;
            line-height: 22px;
          `}>
          {t('setting_modal_footer_text')}{' '}
          <a href="mailto:help@anaphora.tech">help@anaphora.tech</a>
        </div>
      </Content>
      <Actions
        leftActions={
          <Button onClick={handleClose} type="secondary" disabled={submitting}>
            {t('close')}
          </Button>
        }
        rightActions={
          <Button
            onClick={handleUpdateLanguageAndTimezone}
            type="primary"
            disabled={submitting}>
            {t('save')}
          </Button>
        }
      />
    </Modal>
  )
}
